<template>
  <!-- ROOF MADE -->
  <question-base-wrapper
    title="What is the roof made of?"
    v-bind="baseWrapperProps"
  >
    <validation-provider
      v-slot="{ failed, failedRules }"
      :vid="`${stepId}_property-roof-made`"
      name="Property Roof"
      :rules="{ is_not: { other: null } }"
      slim
    >
      <radio
        v-model="propertyRoofMadeModel"
        name="property-roof-made"
        column
        wide
        return-object
        :error="failed"
        :error-messages="getFieldErrors('propertyRoofMade', failedRules)"
        :items="propertyRoofMadeGeneric"
        :data-test="snakeCase(questionFields.propertyRoofMade)"
      />
    </validation-provider>
    <template
      v-if="isPropertyRoofMadeOther"
    >
      <validation-provider
        id="home_propertyRoofMade-other"
        v-slot="{ errors, failed }"
        name="Property Roof Other"
        :vid="`${stepId}_property-roof-made`"
        rules="listOptionRequired"
        tag="div"
      >
        <qz-select
          v-model="questionData.propertyRoofMade"
          :items="propertyRoofMadeOther"
          :placeholder="helpers.getPlaceholderResponsiveText('Please choose the material', isMobile)"
          :error="failed"
          :error-messages="errors"
          class="mt-4"
          :data-test="`${snakeCase(questionFields.propertyRoofMade)}_other`"
        />
      </validation-provider>
    </template>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

import {
  omit,
  pick,
} from 'lodash';

export default {
  name: 'question-property-roof',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyRoofMade'],
    };
  },
  computed: {
    propertyRoofMadeModel: {
      get () {
        if (this.helpers.isNull(this.questionData.propertyRoofMade)) return null;
        return this.constants.HOME_PROPERTY_ROOF_MADE_FAVORITES.includes(this.questionData.propertyRoofMade) ? this.questionData.propertyRoofMade : true;
      },
      set (val) {
        this.questionData.propertyRoofMade = val.logical ? val.logicalValue : val.value;
      },
    },

    propertyRoofMadeOther () {
      return this.helpers.createOptions({ source: omit(this.constants.HOME_PROPERTY_ROOF_MADE, this.constants.HOME_PROPERTY_ROOF_MADE_FAVORITES) });
    },

    propertyRoofMadeGeneric () {
      return [
        ...this.helpers.createOptions({ source: pick(this.constants.HOME_PROPERTY_ROOF_MADE, this.constants.HOME_PROPERTY_ROOF_MADE_FAVORITES) }), this.helpers.otherOption()];
    },

    isPropertyRoofMadeOther () {
      return !this.helpers.isNull(this.questionData.propertyRoofMade) && !this.constants.HOME_PROPERTY_ROOF_MADE_FAVORITES.includes(this.questionData.propertyRoofMade);
    },
  },
};
</script>
